import { cn, PaginationItemType, usePagination } from "@nextui-org/react";

// STYLES
import styles from "./Stepper.module.scss";

// ASSETS
import ChevronIcon from "../..//assets/images/icons/ui/arrows/chevron-icon.svg?react";

type PaginationReturn = ReturnType<typeof usePagination>;

interface StepperProps {
  pagination: PaginationReturn;
  classNames?: {
    stepItem?: string;
    stepButton?: string;
    paginationList?: string;
  };
}

export const Stepper = ({ pagination, classNames }: StepperProps) => {
  const { paginationList, stepItem, controls, stepButton, active } = styles;

  const { activePage, range, setPage, onNext, onPrevious } = pagination;

  return (
    <div className="flex flex-col gap-2">
      <ul
        className={`${paginationList} ${classNames?.paginationList ? classNames.paginationList : ""}`}
      >
        {range.map((page) => {
          if (
            page === PaginationItemType.NEXT ||
            page === PaginationItemType.PREV
          ) {
            const isNext = page === PaginationItemType.NEXT;
            return (
              <li
                key={page}
                className={`${stepItem} ${classNames?.stepItem ? classNames?.stepItem : ""}`}
              >
                <button
                  className={`${stepButton} ${classNames?.stepButton ? classNames?.stepButton : ""}`}
                  onClick={isNext ? onNext : onPrevious}
                >
                  <ChevronIcon
                    className={cn(controls, !isNext && "rotate-180")}
                  />
                </button>
              </li>
            );
          }

          if (page === PaginationItemType.DOTS) {
            return (
              <li
                key={page}
                className={`${stepItem} ${classNames?.stepItem ? classNames?.stepItem : ""}`}
              >
                <span className="text-[10px]">...</span>
              </li>
            );
          }

          return (
            <li
              key={page}
              className={`${stepItem} ${classNames?.stepItem ? classNames?.stepItem : ""}`}
            >
              <button
                className={`${cn(stepButton, activePage >= page && active)} ${classNames?.stepButton ? classNames?.stepButton : ""}`}
                onClick={() => setPage(page)}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
